import { useMutation } from '@tanstack/react-query';
import { IModifyDriverBody } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const modifyDriver = async (id: string, body: IModifyDriverBody) => {
  const res = await apiManager.patch(`/admin/driver/${id}/modify`, body);
  return res;
};


export const useModifyDriver = () =>
  useMutation({
    mutationFn: async ({ id, body }: { id: string; body: IModifyDriverBody }) => {
      const res = await apiClient.patch(ENDPOINTS.DRIVER.MODIFY_DRIVER(id), body);
      return res.data;
    },
  });